<bootstrap-popup
	[id]="'editEntrepriseDialog'"
	[title]="title"
	[modalSize]="'modal-lg'"
	[windowCloseButton]="true"
	[displaySubject]="popupVisibility$"
	>
	<form *ngIf="entreprise" role="form" class="form-horizontal" >

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label">Nom* : </label>
			<div class="col-sm-9">
				<suggestable-input
					[inputClass]="'form-control'"
					[suggestionsObservableGetter]="observablePourSuggestionNom"
					[placeholder]="'Entrer le nom de l\'entreprise'"
					[categoryBuilders]="suggestionCategoryBuilders"
					[labelGetter]="getSuggestionsLabel"
					[labelAsHtml]="true"
					[inputLabelGetter]="getSuggestionsLabelForInput"
					[(value)]= "entreprise.nom"
					(valueChange)= "entreprise.nom = $event"
					(valueSelected)= "onSuggestionNomSelected($event)"
					>
				</suggestable-input>
			</div>
		</div>

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label">SIRET :</label>
			<div class="col-sm-9">
				<input type="text" id="siretID" name="siret"
					class="form-control" placeholder="Entrer le SIRET"
					maxlength="14" [(ngModel)]="entreprise.siret" 
					oninput="this.value = this.value.replace(/[^0-9]/g, '')"/>
			</div>
		</div>
		
		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label">Rue :</label>
			<div class="col-sm-9">
				<input type="text" id="rueID" name="rue"
					class="form-control" placeholder="Entrer la rue"
					maxlength="100" [(ngModel)]="entreprise.adresseRue" />
			</div>
		</div>
		
		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label">Code postal :</label>
			<div class="col-sm-4">
				<input type="text" id="codePostalID" name="codePostal"
					class="form-control" placeholder="Code postal"
					maxlength="5" [(ngModel)]="entreprise.adresseCodePostal" 
					oninput="this.value = this.value.replace(/[^0-9]/g, '')"/>
			</div>
		</div>
		
		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label">Ville :</label>
			<div class="col-sm-9">
				<input type="text" id="villeID" name="ville"
					class="form-control" placeholder="Entrer la ville"
					maxlength="100" [(ngModel)]="entreprise.adresseVille" />
			</div>
		</div>

		<div class="form-group col-sm-12">
		  	<label class="col-sm-3 control-label">Document applicable&nbsp;*:</label>
		  	<div class="col-sm-9">
				<label class="doc-applicable checkbox-line" *ngFor="let docApplicable of applicationConstants.documentApplicable; let index = index">
					<input type="checkbox" name="documentApplicable" 
						[(ngModel)]="selectionDocumentApplicable[index]" [ngModelOptions]="{standalone: true}" />
					{{ docApplicable.label }}
				</label>
		  	</div>
		</div>
		
		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="caobsolete">Actif&nbsp;*:</label>
			<div class="col-sm-9">
				<label class="radio-inline">
					<input type="radio"
						id="isObsolete_non" name="isObsolete"
						[value]="false"
						[(ngModel)]="entreprise.obsolete"
						>
					Oui
				</label>
				<label class="radio-inline">
					 <input type="radio"
						id="isObsolete_oui" name="isObsolete"
						[value]="true"
						[(ngModel)]="entreprise.obsolete"
						>
					Non
				</label> 
			</div>
		</div>

		<div class="form-group text-center">
			<button type="submit" class="btn btn-success" [disabled]="waitingForServer" (click)="save()">
				{{ mode === modes.CREATION ? 'Ajouter' : 'Modifier' }}
			</button>
		</div>
	</form>

	<div ui-view="messageZone"></div>
</bootstrap-popup>